package editor

/**
 * - HOVERING: user can freely target elements, orbit around the screen etc.
 * - PLACING: user decided to place an element and can fine-tune position and rotation
 *
 * @see EditorManager
 */
enum class EditorState(val allowOrbit: Boolean = true) {
    HOVERING, PLACING(allowOrbit = false)
}